import { FC, useMemo, useEffect } from "react";
import {
  NavLink,
  NavLinkProps,
  useLocation,
  useResolvedPath,
} from "react-router-dom";
import styled from "styled-components";
import Box from "./Box";
import MobileBox from "./MobileBox";
import { getPathMatch } from "./utils";

export const Container = styled.div`
  transition: 0.2s;
  a {
    outline: none !important;
  }
  a:focus > div {
    /* outline: medium solid black; */
  }
  a > div,
  a:focus > div {
    outline-offset: -3px;
    outline-width: 2px;
    transition-property: background-color, color;
  }
`;

type NavigationLinkProps = {
  title: string | JSX.Element;
  icon?: React.ReactElement;
  activeLink?: string;
  isMobileBox?: true;
  variant?: "classic" | "profile";
  onActive?: () => void;
  disabled?: boolean;
  locked?: boolean;
} & Omit<NavLinkProps, "title">;
const NavigationLink: FC<NavigationLinkProps> = ({
  title,
  icon,
  to,
  activeLink,
  isMobileBox,
  variant = "classic",
  onActive,
  disabled,
  locked,
  ...props
}) => {
  // Code copied directly from the NavLink definition
  const location = useLocation();
  const path = useResolvedPath(activeLink || to);

  const active = useMemo(() => {
    const { isPath, isSubPath } = getPathMatch(location, path);
    return isPath || isSubPath;
  }, [location, path]);

  useEffect(() => {
    active && !disabled && onActive?.();
  }, [active, onActive, disabled]);

  const content = isMobileBox ? (
    <MobileBox
      active={!onActive && active}
      disabled={disabled}
      locked={locked}
    >
      {icon}
      <div className="title">{title}</div>
    </MobileBox>
  ) : (
    <Box active={!onActive && active} variant={variant} disabled={disabled}>
      {icon || <div className="no-icon" />}
      <div className="title">{title}</div>
    </Box>
  );

  if (disabled) {
    return (
      <Container
        onClick={(e) => {
          e.preventDefault();
          (props.onClick as any)?.(e);
        }}
        style={
          isMobileBox
            ? {
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }
            : {}
        }
      >
        {content}
      </Container>
    );
  }

  return (
    <Container>
      <NavLink {...props} to={to}>
        {content}
      </NavLink>
    </Container>
  );
};

export default NavigationLink;
